module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/images/top_picture_narrow-0e165e4af8e228c92f660adfbb9e4e97.jpg";